import { useQuery } from '@tanstack/react-query';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';
import { Dictionary } from 'lodash';

export const FEATURE_FLAGS = {
  notificationCentre: 'notifications_centre',
};

export const fetchFeatureFlags = async () => {
  const response = await CustomAxios.get<Dictionary<boolean>>(`user-features`);
  const { data } = response;
  return data;
};

export function useGetFeatureFlags() {
  const query = useQuery({
    queryKey: [queryKeys.featureFlags],
    queryFn: fetchFeatureFlags,
    staleTime: 1000 * 60 * 60, // unlikely to change for the lifetime of the session
  });

  return query;
}
